(() => {
  const deferredSourceAttributes = ['src', 'srcset'];

  function promoteImage(image) {
    if (!image) return;

    let promoted = false;
    deferredSourceAttributes.forEach((attribute) => {
      const deferredAttribute = `data-deferred-${attribute}`;
      const value = image.getAttribute(deferredAttribute);
      if (!value) return;

      image.setAttribute(`data-${attribute}`, value);
      image.removeAttribute(deferredAttribute);
      promoted = true;
    });

    if (!promoted) return;

    image.classList.add('lazyload');
    window.lazySizes?.loader?.unveil(image);
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.priorityGalleryReady === 'true') return;

    const mainCarousel = gallery.querySelector('.js-product-main-carousel');
    if (!mainCarousel) return;

    gallery.dataset.priorityGalleryReady = 'true';

    const slides = Array.from(
      mainCarousel.querySelectorAll('.swiper-slide[data-media-id]'),
    );
    const activeIndex = () =>
      Math.max(
        0,
        slides.findIndex((slide) =>
          slide.classList.contains('swiper-slide-active'),
        ),
      );
    const promoteSlide = (slide) =>
      promoteImage(slide?.querySelector('img[data-deferred-src]'));
    const promoteAdjacent = () => {
      const index = activeIndex();
      promoteSlide(slides[index - 1]);
      promoteSlide(slides[index + 1]);
    };
    const promoteByMediaId = (mediaId) => {
      if (!mediaId) return;
      promoteSlide(
        slides.find((slide) => slide.dataset.mediaId === mediaId),
      );
    };

    mainCarousel.addEventListener('pointerdown', promoteAdjacent, {
      passive: true,
      capture: true,
    });
    mainCarousel.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          promoteAdjacent();
        }
      },
      true,
    );
    mainCarousel.addEventListener(
      'click',
      (event) => {
        if (
          event.target.closest('.swiper-button-next') ||
          event.target.closest('.swiper-button-prev')
        ) {
          promoteAdjacent();
        }
      },
      true,
    );

    const previews = gallery.querySelector('.js-product-previews-carousel');
    if (previews) {
      const promotePreviewTarget = (event) => {
        const preview = event.target.closest('[data-media-id]');
        promoteByMediaId(preview?.dataset.mediaId);
      };
      previews.addEventListener('pointerdown', promotePreviewTarget, true);
      previews.addEventListener('mouseover', promotePreviewTarget, true);
      previews.addEventListener('focusin', promotePreviewTarget, true);
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (target.classList.contains('swiper-slide-active')) {
          promoteSlide(target);
        }
      });
    });
    slides.forEach((slide) =>
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class'],
      }),
    );
  }

  document.querySelectorAll('product-gallery').forEach(initializeGallery);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('product-gallery').forEach(initializeGallery);
  });
})();
